<template>
  <div>
    <GpBrandImage />
    <p class="tw-font-bold">
      <slot name="text" />
    </p>
    <slot name="button" />
  </div>
</template>

<script lang="ts">
import { GpBrandImage } from '@gportal/uikit';

export default {
  components: {
    GpBrandImage,
  },
};
</script>
